// @generated by protoc-gen-connect-es v1.1.3 with parameter "target=ts"
// @generated from file gdx/gateway/web/compatibility/v1/compatibility_api.proto (package gdx.compatibility.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { ActivateCompatibilityStatusRequest, ActivateCompatibilityStatusResponse, ActivateSexualCompatibilityStatusRequest, ActivateSexualCompatibilityStatusResponse, BatchGetCompatibilityStatusesRequest, BatchGetCompatibilityStatusesResponse, BatchGetSexualCompatibilityStatusesRequest, BatchGetSexualCompatibilityStatusesResponse, GetCompatibilityStatusRequest, GetCompatibilityStatusResponse, GetSexualCompatibilityStatusRequest, GetSexualCompatibilityStatusResponse } from "./compatibility_api_pb.js";
import { MethodKind } from "@bufbuild/protobuf";

/**
 * Implements all profile related APIs.
 *
 * @generated from service gdx.compatibility.v1.CompatibilityAPI
 */
export const CompatibilityAPI = {
  typeName: "gdx.compatibility.v1.CompatibilityAPI",
  methods: {
    /**
     * Returns compatibility status.
     *
     * @generated from rpc gdx.compatibility.v1.CompatibilityAPI.GetCompatibilityStatus
     */
    getCompatibilityStatus: {
      name: "GetCompatibilityStatus",
      I: GetCompatibilityStatusRequest,
      O: GetCompatibilityStatusResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Returns compatibility statuses.
     *
     * @generated from rpc gdx.compatibility.v1.CompatibilityAPI.BatchGetCompatibilityStatuses
     */
    batchGetCompatibilityStatuses: {
      name: "BatchGetCompatibilityStatuses",
      I: BatchGetCompatibilityStatusesRequest,
      O: BatchGetCompatibilityStatusesResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Returns success or fail buy compatibility status.
     *
     * @generated from rpc gdx.compatibility.v1.CompatibilityAPI.ActivateCompatibilityStatus
     */
    activateCompatibilityStatus: {
      name: "ActivateCompatibilityStatus",
      I: ActivateCompatibilityStatusRequest,
      O: ActivateCompatibilityStatusResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Returns compatibility status.
     *
     * @generated from rpc gdx.compatibility.v1.CompatibilityAPI.GetSexualCompatibilityStatus
     */
    getSexualCompatibilityStatus: {
      name: "GetSexualCompatibilityStatus",
      I: GetSexualCompatibilityStatusRequest,
      O: GetSexualCompatibilityStatusResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Returns compatibility statuses.
     *
     * @generated from rpc gdx.compatibility.v1.CompatibilityAPI.BatchGetSexualCompatibilityStatuses
     */
    batchGetSexualCompatibilityStatuses: {
      name: "BatchGetSexualCompatibilityStatuses",
      I: BatchGetSexualCompatibilityStatusesRequest,
      O: BatchGetSexualCompatibilityStatusesResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Returns success or fail buy compatibility status.
     *
     * @generated from rpc gdx.compatibility.v1.CompatibilityAPI.ActivateSexualCompatibilityStatus
     */
    activateSexualCompatibilityStatus: {
      name: "ActivateSexualCompatibilityStatus",
      I: ActivateSexualCompatibilityStatusRequest,
      O: ActivateSexualCompatibilityStatusResponse,
      kind: MethodKind.Unary,
    },
  }
} as const;

